import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { NewsPage } from './pages/NewsPage';
import { NewsPostPage } from './pages/NewsPostPage';
import { DonatePage } from './pages/DonatePage';
import { LoginPage } from './pages/LoginPage';
import { ContactsPage } from './pages/ContactsPage';
import { AngelsPage } from './pages/AngelsPage';
import { FaqPage } from './pages/FaqPage';
import { CalendarPage } from './pages/CalendarPage';
import { FederationIndex } from './pages/federation/FederationIndex';
import { Presidia } from './pages/federation/Presidia';
import { SupervisoryBoard } from './pages/federation/SupervisoryBoard';
import { VeteransCouncil } from './pages/federation/VeteransCouncil';
import { EducationCommission } from './pages/federation/EducationCommission';
import { Subdivisions } from './pages/federation/Subdivisions';
import { Decisions } from './pages/federation/Decisions';
import { Documents } from './pages/federation/Documents';
import { ClimbingIndex } from './pages/climbing/ClimbingIndex';
import { ClimbingCommittee } from './pages/climbing/ClimbingCommittee';
import { CoachCouncil } from './pages/climbing/CoachCouncil';
import { JudgesBoard } from './pages/climbing/JudgesBoard';
import { SportClimbingCommission } from './pages/climbing/SportClimbingCommission';
import { EducationMethodCommission } from './pages/climbing/EducationMethodCommission';
import { AthletesCommission } from './pages/climbing/AthletesCommission';
import { EthicsCommission } from './pages/climbing/EthicsCommission';
import { AntidopingCommission } from './pages/climbing/AntidopingCommission';
import { ClimbingDocuments } from './pages/climbing/ClimbingDocuments';
import { AlpinismIndex } from './pages/alpinism/AlpinismIndex';
import { AlpinismCommittee } from './pages/alpinism/AlpinismCommittee';
import { AlpinismCoachCouncil } from './pages/alpinism/AlpinismCoachCouncil';
import { AlpinismJudgesBoard } from './pages/alpinism/AlpinismJudgesBoard';
import { RouteClassificationCommission } from './pages/alpinism/RouteClassificationCommission';
import { SkiAlpinismCommission } from './pages/alpinism/SkiAlpinismCommission';
import { AmateurAlpinismCommission } from './pages/alpinism/AmateurAlpinismCommission';
import { AlpinismDocuments } from './pages/alpinism/AlpinismDocuments';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/news" element={<NewsPage data-id="element-5" />} data-id="element-4" />
        <Route path="/news/:id" element={<NewsPostPage data-id="element-7" />} data-id="element-6" />
        <Route path="/login" element={<LoginPage data-id="element-9" />} data-id="element-8" />
        <Route path="/contacts" element={<ContactsPage data-id="element-11" />} data-id="element-10" />
        <Route path="/angels" element={<AngelsPage data-id="element-13" />} data-id="element-12" />
        <Route path="/faq" element={<FaqPage data-id="element-15" />} data-id="element-14" />
        <Route path="/calendar" element={<CalendarPage data-id="element-17" />} data-id="element-16" />
        <Route path="/donate" element={<DonatePage data-id="element-19" />} data-id="element-18" />
        <Route path="/federation" element={<FederationIndex data-id="element-21" />} data-id="element-20" />
        <Route path="/federation/presidia" element={<Presidia data-id="element-23" />} data-id="element-22" />
        <Route path="/federation/supervisory-board" element={<SupervisoryBoard data-id="element-25" />} data-id="element-24" />
        <Route path="/federation/veterans-council" element={<VeteransCouncil data-id="element-27" />} data-id="element-26" />
        <Route path="/federation/education-commission" element={<EducationCommission data-id="element-29" />} data-id="element-28" />
        <Route path="/federation/subdivisions" element={<Subdivisions data-id="element-31" />} data-id="element-30" />
        <Route path="/federation/decisions" element={<Decisions data-id="element-33" />} data-id="element-32" />
        <Route path="/federation/documents" element={<Documents data-id="element-35" />} data-id="element-34" />

        {/* Alpinism Routes */}
        <Route path="/alpinism" element={<AlpinismIndex data-id="element-37" />} data-id="element-36" />
        <Route path="/alpinism/committee" element={<AlpinismCommittee data-id="element-39" />} data-id="element-38" />
        <Route path="/alpinism/coach-council" element={<AlpinismCoachCouncil data-id="element-41" />} data-id="element-40" />
        <Route path="/alpinism/judges" element={<AlpinismJudgesBoard data-id="element-43" />} data-id="element-42" />
        <Route path="/alpinism/route-classification" element={<RouteClassificationCommission data-id="element-45" />} data-id="element-44" />
        <Route path="/alpinism/ski-alpinism" element={<SkiAlpinismCommission data-id="element-47" />} data-id="element-46" />
        <Route path="/alpinism/amateur" element={<AmateurAlpinismCommission data-id="element-49" />} data-id="element-48" />
        <Route path="/alpinism/documents" element={<AlpinismDocuments data-id="element-51" />} data-id="element-50" />

        {/* Climbing Routes */}
        <Route path="/climbing" element={<ClimbingIndex data-id="element-53" />} data-id="element-52" />
        <Route path="/climbing/committee" element={<ClimbingCommittee data-id="element-55" />} data-id="element-54" />
        <Route path="/climbing/coach-council" element={<CoachCouncil data-id="element-57" />} data-id="element-56" />
        <Route path="/climbing/judges" element={<JudgesBoard data-id="element-59" />} data-id="element-58" />
        <Route path="/climbing/sport-commission" element={<SportClimbingCommission data-id="element-61" />} data-id="element-60" />
        <Route path="/climbing/education" element={<EducationMethodCommission data-id="element-63" />} data-id="element-62" />
        <Route path="/climbing/athletes" element={<AthletesCommission data-id="element-65" />} data-id="element-64" />
        <Route path="/climbing/ethics" element={<EthicsCommission data-id="element-67" />} data-id="element-66" />
        <Route path="/climbing/antidoping" element={<AntidopingCommission data-id="element-69" />} data-id="element-68" />
        <Route path="/climbing/documents" element={<ClimbingDocuments data-id="element-71" />} data-id="element-70" />
      </Routes>
    </BrowserRouter>;
}